import { combineSlices, configureStore } from '@reduxjs/toolkit';
import reduxLogger from '@ricoh/ria.client.core/plugins/store/middlewares/logger';
import componentDialogSlice from '@ricoh/ria.client.core/plugins/store/slices/component/dialog';
import componentLayoutSlice from '@ricoh/ria.client.core/plugins/store/slices/component/layout';
import componentPopupSlice from '@ricoh/ria.client.core/plugins/store/slices/component/popup';

import authSlice from '~/plugins/store/slices/feature/auth';
import chatbotSlice from '~/plugins/store/slices/feature/chatbot';
import processSlice from '~/plugins/store/slices/feature/process';
import settingsBatchTypeLibrarySlice from '~/plugins/store/slices/feature/settings/batch-type-library';
import pluginLeadtoolsSlice from '~/plugins/store/slices/plugin/leadtools';

const storeReducer = combineSlices(
  // Components
  componentDialogSlice,
  componentLayoutSlice,
  componentPopupSlice,

  // Plugins
  pluginLeadtoolsSlice,

  // Features
  authSlice,
  chatbotSlice,
  settingsBatchTypeLibrarySlice,
  processSlice,
);

/** Store. */
export const store = configureStore({
  reducer: storeReducer,
  middleware: (getDefaultMiddleware) => {
    if (import.meta.env.PROD) {
      return getDefaultMiddleware({
        immutableCheck: false,
        serializableCheck: false,
        actionCreatorCheck: false,
      });
    }

    return getDefaultMiddleware().concat(reduxLogger);
  },
});
